import ArticleFeed from '../components/ArticleFeed';
export default function Home() { return <ArticleFeed />; }
